



























import { Component, Vue, Prop, Provide, Watch } from 'vue-property-decorator'
import SingleRowSelect from '@/components/common/singleRowSelect/SingleRowSelect.vue'

@Component({
  components: { SingleRowSelect }
})
export default class TopFilter2 extends Vue {
  @Prop() site!: any
  public filterList: any = [{
    name: '资源类型：',
    label: 'sourceType',
    val: []
  }, {
    name: '微课类型：',
    label: 'courseType',
    val: [{ name: '全部', val: '' }, { name: '讲解微课', val: 'EXPLAIN' }, { name: '例题微课', val: 'EXAMPLE' }, { name: '高频错题', val: 'ERROR_QUESTION' }]
  }]
  // subjectId
  private get subjectId() {
    return this.$store.state.subject.value
  }
  // sourceType
  private get sourceType() {
    return this.$store.state.question.sourceType || 1
  }
  // mounted
  public mounted() {
    if (!this.subjectId) return
    // 小英展示绘本
    if ([101, 102, 103].includes(this.subjectId) && this.subjectId === 103) {
      this.filterList[0].val = [{name: '课件', val: 1}, {name: '微课', val: 2}, {name: '绘本', val: 3}]
    }
    // 小学展示课件和微课
    if ([101, 102, 103].includes(this.subjectId) && this.subjectId !== 103) {
      this.filterList[0].val = [{name: '课件', val: 1}, {name: '微课', val: 2}]
    }
    // 初数、初语、初英展示课件、微课
    if ([201, 202, 203].includes(this.subjectId)) {
      this.filterList[0].val = [{name: '课件', val: 1}, {name: '微课', val: 2}]
    }
    // 其他展示微课
    if ([204, 205, 302, 304, 305].includes(this.subjectId)) {
      this.filterList[0].val = [{name: '微课', val: 2}]
    }
    this.$store.commit('SET_SOURCE_TYPE', 1)
  }
  // getChoose
  public getChoose(val: any) {
    switch (val.group) {
      case '资源类型：':
        window['sensors'].track('TIKU_filter_clk', {
          moduleName: '课件·微课·绘本',
          filter: '资源类型',
          value: val.name,
          paper_type: ''
        })
        this.$store.commit('SET_SOURCE_TYPE', val.value)
        break
      case '微课类型：':
        this.$store.commit('SET_COURSE_TYPE', val.value)
        break
      default:
        break
    }
  }
}
